export function RouteFallback() {
  return (
    <div role="status" aria-live="polite" style={{ padding: "var(--ff-space-6)" }}>
      <span className="ff-visually-hidden">Loading</span>
    </div>
  );
}
